import { useEffect, useState } from "react";
import clsx from "clsx";

interface AssetIconProps {
  src: string;
  fallback: string;
  alt?: string;
  className?: string;
  emojiClassName?: string;
}

/** PNG icon with emoji fallback when the asset file is missing. */
export function AssetIcon({
  src,
  fallback,
  alt = "",
  className = "w-10 h-10 object-contain",
  emojiClassName = "text-2xl leading-none",
}: AssetIconProps) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (failed) {
    return <span className={emojiClassName}>{fallback}</span>;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={clsx(className)}
      onError={() => setFailed(true)}
    />
  );
}
